<template>
  <div id="profile">
    <header>
      <svg 
        id="profile-icon"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 16 19.67">
        <path d="M8,0A28.32,28.32,0,0,1,0,2.52V8A12.49,12.49,0,0,0,8,19.67,12.49,12.49,0,0,0,16,8V2.52A28.32,28.32,0,0,1,8,0ZM9,9.24v3.28a1,1,0,0,1-2,0V9.24A2,2,0,0,1,6,7.52a2,2,0,0,1,4,0A2,2,0,0,1,9,9.24Z"/>
      </svg>
      <h1>Profile &amp; Privacy</h1>
      <button 
        class="hide"
        @click.prevent="hideClicked">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 12 12">
          <polygon 
            class="cls-2" 
            points="9.71 3.71 8.29 2.29 6 4.59 3.71 2.29 2.29 3.71 4.59 6 2.29 8.29 3.71 9.71 6 7.41 8.29 9.71 9.71 8.29 7.41 6 9.71 3.71"/></svg>
      </button>
    </header>

    <main v-if="loading">
      <h2 id="loading">Loading...</h2>
    </main>

    <main v-if="!loading">
      <div class="line">
        <h2>NECESSARY <span>(required)</span>&nbsp;<span class="gray">optional*</span></h2>
      </div>

      <div class="line">
        <input 
          v-model="password"
          type="password"
          @click.prevent="password = ''"
          @blur.prevent="password = passwordFiller">
        <button 
          :disabled="!password || password === passwordFiller"
          class="action"
          @click.prevent="changePassword(password)">CHANGE</button>
      </div>

      <div class="line">
        <input 
          v-model="auth.displayName"
          type="text"
          placeholder="name">
      </div>

      <div class="line">
        <input
          v-model="auth.email"
          type="email"
          placeholder="email">
      </div>

      <div class="line">
        <select 
          v-if="!customJob && !user.jobCustom"
          v-model="user.job"
          :class="{ 'selected': user.job }"
          @change="customJobSelectCheck">
          <option
            disabled
            selected
            value>job*</option>
          <option 
            v-for="job in jobs"
            :key="job"
            :value="job">{{ job }}</option>
          <option value="other">other</option>
        </select>

        <input
          v-if="customJob || user.jobCustom"
          ref="custom-job"
          v-model="user.jobCustom"
          type="text"
          placeholder="job*"
          @blur="customJobBlur">
      </div>

      <div class="line">
        <input
          v-model="user.company"
          type="text"
          placeholder="company*">
      </div>

      <div class="line">
        <select 
          v-model="user.country"
          :class="{ 'selected': user.country }">
          <option
            disabled
            value="">country*</option>
          <option 
            v-for="country in countries"
            :key="country.name"
            :value="country.name">{{ country.name }}</option>
        </select>
      </div>

      <div class="line">
        <strong id="account">ACCOUNT</strong>
        <button 
          class="action"
          @click.prevent="deleteAccount">DELETE</button>
      </div>

      <div class="line">
        <h2>STATISTICS <span>(functional)</span></h2>
      </div>

      <label>
        <input 
          v-model="user.optInStats"
          type="checkbox"
          @click="toggleOptInStats(!user.optInStats)">
        <p>
          We keep track of usage  stats for the purposes  of understanding and  validating the active  use of this BETA 
          including: Downloads of RECORD apps, frequency of use, duration  of use, and the frequency  of functions.
        </p>
      </label>

      <div class="line">
        <h2 id="statistics-title">FEEDBACK <span>(inquiry &amp; marketing)</span></h2>
      </div>

      <label>
        <input
          v-model="user.optInEmail"
          type="checkbox">
        <p>
          We request to follow up with you via Email to ask questions and survey your on-going experince with the 
          D-Cipher BETA.
        </p>
      </label>

      <div class="line">
        <h2>GENRAL <span>(policy)</span></h2>
      </div>
      <p><a href="#">Privacy Notice<span> ▶</span></a></p>
      <p><a href="#">Cookie Declaration<span> ▶</span></a></p>
    </main>

    <footer>
      <button 
        id="save" 
        @click.prevent="save">SAVE</button>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import { mapGetters } from 'vuex'
import stats from '../../lib/stats/stats'

const typeformEmbed = require('@typeform/embed')

export default {
  name: 'Profile',
  data() {
    const passwordFiller = '********************'
    return {
      loading: true,
      auth: {},
      user: {
        job: '',
        jobCustom: '',
        company: '',
        country: '',
        optInEmail: false,
        optInStats: false,
      },
      jobs: [
        'UX Designer',
        'UI Designer',
        'User Researcher',
        'Usability Tester',
        'Accessibility Expert',
        'Data Analyst/Scientist',
        'Front-End Developer',
        'Full Stack Developer',
        'Product Manager/Owner',
        'Growth Hacker',
        'Marketeer',
        'Entrepreneur',
      ],
      customJob: false,
      passwordFiller,
      password: passwordFiller,
      countries: [],
    }
  },
  computed: {
    ...mapGetters(['relativeWidth', 'relativeHeight']),
  },
  created() {
    this.$eventBus.$on('cookies-accepted', () => {
      this.user.optInStats = true
      this.user.optInEmail = true
      this.save()
    })

    firebase.auth().onAuthStateChanged(auth => {
      this.auth = auth

      let userPromise
      if (this.auth && this.auth.uid) {
        userPromise = this.$firestore
          .collection('users')
          .doc(this.auth.uid)
          .get()
          .then(doc => {
            const docData = doc.data()
            if (docData) {
              Object.assign(this.user, doc.data())
            }
          })
      } else {
        userPromise = Promise.resolve({})
      }

      const countriesPromise = fetch('https://restcountries.eu/rest/v1/all')

      userPromise
        .then(() => countriesPromise)
        .then(response => response.json())
        .then(json => {
          this.countries = json
          this.loading = false
        })
    })
  },
  methods: {
    hideClicked() {
      this.$emit('hide')
    },
    changePassword(newPassword) {
      this.auth
        .updatePassword(newPassword)
        .then(() => console.log('Password updated!'))
        .catch(e => console.error(e))
    },
    toggleOptInStats(newValue) {
      stats.setOptInStats(newValue)
    },
    customJobSelectCheck(changeEvent) {
      if (changeEvent.target.value === 'other') {
        this.customJob = true
        Vue.nextTick(() => {
          this.user.job = ''
          const customJobEl = this.$refs['custom-job']
          customJobEl.focus()
          customJobEl.select()
        })
      }
    },
    customJobBlur() {
      this.customJob = false
    },
    save() {
      const updateEmail = this.auth.updateEmail(this.auth.email)
      const updateName = this.auth.updateProfile({ displayName: this.auth.displayName })
      const updateSettings = this.$firestore
        .collection('users')
        .doc(this.auth.uid)
        .update(this.user)

      updateEmail
        .then(() => updateName)
        .then(() => updateSettings)
        .then(() => this.$emit('hide'))
        .catch(e => console.error(e))
    },
    deleteAccount() {
      window.addEventListener('beforeunload', unloadEvent => {
        this.auth.delete()
        unloadEvent.returnValue = "You haven't finished the exit survey yet"
        return unloadEvent
      })
      typeformEmbed
        .makePopup('https://ux-flo.typeform.com/to/jMPsEf', {
          mode: 'drawer_right',
          onSubmit: () => this.auth.delete(),
        })
        .open()
    },
  },
}
</script>

<style lang="scss">
img[alt='close-typeform'] {
  display: none;
}

#profile {
  position: absolute;
  background: #e6e6e6;
  box-sizing: border-box;
  right: 0;
  bottom: 0;
  width: 365px;
  height: 755px;
  z-index: 100;

  h1 {
    font-size: 14pt;
    font-weight: bold;
    padding: 2px 0 0;
    float: left;
  }

  #loading {
    margin: 50% 30%;
  }

  main {
    clear: both;
    padding: 0 24px;
  }

  h2 {
    font-size: 12pt;
    font-style: italic;
    color: #ff04a5;
  }

  h2 span {
    font-weight: normal;
  }

  h2 span.gray {
    color: #999;
  }

  #profile-icon {
    width: 16px;
    height: 16px;
    margin: 8px 16px 8px 8px;
    float: left;
  }

  .hide {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    width: 12px;
    height: 12px;
    cursor: pointer;
  }

  .hide:hover {
    background: #fff;
  }

  .hide svg {
    width: 12px;
    height: 12px;
  }

  main .line {
    margin: 14px 0;
    clear: both;
  }

  input,
  main .line strong {
    width: 230px;
  }

  main .line strong {
    display: inline-block;
  }

  input[type='text'],
  input[type='password'],
  input[type='email'] {
    border-bottom: 1px solid #cecece;
    font-weight: bold;
  }

  input::placeholder {
    font-style: italic;
    font-weight: normal;
  }

  input[type='checkbox'] {
    float: left;
  }

  label p {
    margin: -4px 0 0 28px;
  }

  .action {
    width: 62px;
    height: 21px;
    margin: 1.5px 0;
    border: 1px solid #cecece;
    border-radius: 20px;
    font-weight: bold;
    text-align: center;
    padding: 0;
    cursor: pointer;
  }

  .action:hover {
    background: #fff;
  }

  .action:disabled {
    cursor: not-allowed;
  }

  p {
    margin: 0 0 14px;
  }

  p a {
    text-decoration: none;
    font-weight: bold;
    color: #53585f;
  }

  p a:hover {
    text-decoration: underline;
  }

  p a span {
    font-size: 7pt;
  }

  footer {
    height: 28px;
  }

  #save {
    width: 52px;
    height: 28px;
    font-size: 11pt;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  #save:hover {
    background: #fff;
  }
}
</style>
